import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { api } from '../services/api'
import { foodCivilToday } from '../utils/foodCivilDate'

export const fetchTodayLogs = createAsyncThunk('nutrition/today', async () => {
  const { data } = await api.get('/nutrition/logs/today')
  return data
})

export const fetchGoals = createAsyncThunk('nutrition/goals', async () => {
  const { data } = await api.get('/nutrition/goals')
  return data
})

export const fetchTrafficLight = createAsyncThunk('nutrition/trafficLight', async () => {
  const { data } = await api.get('/nutrition/traffic-light')
  return data
})

export const addFoodLog = createAsyncThunk('nutrition/addLog', async (dto: any) => {
  const payload = { ...dto, logDate: dto.logDate || foodCivilToday() }
  const { data } = await api.post('/nutrition/logs', payload)
  return data
})

export const deleteFoodLog = createAsyncThunk('nutrition/deleteLog', async (id: string) => {
  await api.delete(`/nutrition/logs/${id}`)
  return id
})

const nutritionSlice = createSlice({
  name: 'nutrition',
  initialState: {
    todayLogs: null as any,
    goals: null as any,
    trafficLight: null as any,
    loading: false,
    /** true solo si falló la carga (no confundir con “día sin registros”). */
    loadError: false,
  },
  reducers: {
    clearNutritionLoadError(s) {
      s.loadError = false
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTodayLogs.fulfilled, (s, a) => {
        s.todayLogs = a.payload
        s.loading = false
        s.loadError = false
      })
      .addCase(fetchTodayLogs.pending, (s) => {
        s.loading = true
        s.loadError = false
      })
      .addCase(fetchTodayLogs.rejected, (s) => {
        s.loading = false
        s.loadError = true
        // No inventar día vacío: eso ocultaba registros reales tras 401/SSO.
      })
      .addCase(fetchGoals.fulfilled, (s, a) => { s.goals = a.payload })
      .addCase(fetchTrafficLight.fulfilled, (s, a) => { s.trafficLight = a.payload })
      .addCase(addFoodLog.fulfilled, (s, a) => {
        s.loading = false
        const log = a.payload
        if (!log?.id) return
        if (!s.todayLogs) {
          s.todayLogs = { logs: [log], totals: null, byMeal: {}, date: log.logDate }
          return
        }
        const logs = [...(s.todayLogs.logs || []), log]
        const meal = log.mealType || 'CUSTOM'
        const byMeal = { ...(s.todayLogs.byMeal || {}) }
        byMeal[meal] = [...(byMeal[meal] || []), log]
        s.todayLogs = { ...s.todayLogs, logs, byMeal }
      })
      .addCase(deleteFoodLog.fulfilled, (s, a) => {
        s.loading = false
        if (s.todayLogs?.logs) {
          s.todayLogs = {
            ...s.todayLogs,
            logs: s.todayLogs.logs.filter((l: any) => l.id !== a.payload),
          }
        }
      })
  },
})

export const { clearNutritionLoadError } = nutritionSlice.actions
export default nutritionSlice.reducer
